import React, { Component } from "react";
import { Layout, Table, Spin } from "antd";
import { Parse } from "parse";
import moment from "moment";

import { FormattedMessage, defineMessages,   injectIntl } from "react-intl";

import MypageNav from "../../components/navigation/MypageNav";
import Headline from "../../components/Headline";

import { getCreditOfUser, getRemittanceDataOfUser } from "../../utils/fetchDataFromDB";
import { processAnFetchData } from "../../utils/errorHandling";

import "../../styles/Mypage.css";

const { Content } = Layout;

const messages = defineMessages({
  date: {
    id: "Mypage.credit.invoice.date",
    defaultMessage: "Date",
  },
  amount: {
    id: "Mypage.credit.invoice.amount",
    defaultMessage: "Amount",
  },
  remittanceStatus: {
    id: "Mypage.credit.invoice.remittanceStatus",
    defaultMessage: "Remittance Status",
  },
  tableNotData: {
    id: "Mypage.credit.invoice.tableNotData",
    defaultMessage: "No application details.",
  },
  remittanceWaitng: {
    id: "Mypage.credit.invoice.remittance.waitng",
    defaultMessage: "Remittance Waitng",
  },
  remittanceCompletion: {
    id: "Mypage.credit.invoice.remittance.completion",
    defaultMessage: "Completion",
  },
});
class Credit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      credit: "0",
      paymentRequestData: [],
    };
  }

  async componentDidMount() {
    const { formatMessage } = this.props.intl;
    const user = Parse.User.current();

    if (user.id === "GbniZVCm5M") {
      //labeler 전용 계정 id
      this.props.history.push("/mypage");
      return;
    }

    let credit = this.props.credit;
    let payoutList = [];

    try {
      credit = await getCreditOfUser(user);
      payoutList = await getRemittanceDataOfUser(user);
    } catch (err) {
      processAnFetchData(err);
      this.setState({ loading: false });
      return;
    }

    const paymentRequestData = payoutList.map((data) => {
      let remittanceStatus = formatMessage(messages.remittanceWaitng);

      if (data.get("payoutStatus")) remittanceStatus = formatMessage(messages.remittanceCompletion) + " (" + moment(data.updatedAt).format("YYYY.MM.DD") + ")";

      return {
        key: data.id,
        date: moment(data.createdAt).format("YYYY.MM.DD"),
        amount: "$ " + data.get("userInfo").paymentRequest,
        remittanceStatus: remittanceStatus,
      };
    });

    this.setState({ loading: false, credit, paymentRequestData });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const columns = [
      {
        title: formatMessage(messages.date),
        dataIndex: "date",
      },
      {
        title: formatMessage(messages.amount),
        dataIndex: "amount",
      },
      {
        title: formatMessage(messages.remittanceStatus),
        dataIndex: "remittanceStatus",
      },
    ];
    return (
      <Layout style={{ background: "#fff", height: "inherit" }}>
        <MypageNav selectedKey={"remittance-info"} />
        <Content style={{ margin: 20, height: "inherit" }}>
          <Headline id="Mypage.credit.headline" defaultMessage="Remittance Information" />
          <Spin spinning={this.state.loading} tip="Loading...">
            <div style={{ margin: "0px 25px" }}>
              <p className="mypage-subtitle" style={{ marginTop: "65px" }}>
                <FormattedMessage id="Mypage.credit.subTitle" defaultMessage="Remittable Revenue" />
              </p>
              <p className="credit">{Number(this.state.credit).toFixed(2)}</p>

              <div style={{ marginTop: "70px" }}>
                <p className="mypage-subtitle">
                  <FormattedMessage id="Mypage.credit.invoice.title" defaultMessage="Remittance Details" />
                </p>
                <Table
                  columns={columns}
                  dataSource={this.state.paymentRequestData}
                  locale={{ emptyText: formatMessage(messages.tableNotData) }}
                  pagination={{ pageSize: 4 }}
                  className="remittance-details-table"
                />
              </div>
            </div>
          </Spin>
        </Content>
      </Layout>
    );
  }
}
 
Credit = injectIntl(Credit);

export default Credit;
